// Pull to refresh, as iOS does it: at the top of the page, pull down past the line and let go.
// Touch only; the page keeps its own scroll. Shows a small line of what it's doing.
import { useEffect, useRef, useState } from "preact/hooks";
import { haptic } from "../lib/haptic";

export function Pull({ onRefresh }: { onRefresh: () => Promise<string> }) {
  const [pull, setPull] = useState(0);
  const [msg, setMsg] = useState<string | null>(null);
  const y0 = useRef<number | null>(null);
  const busy = useRef(false);
  const last = useRef(0);
  useEffect(() => {
    const down = (e: TouchEvent) => { if (window.scrollY <= 0 && !busy.current && !(e.target as Element).closest(".sheet, .scrub, .band-scrub, input, textarea")) y0.current = e.touches[0].clientY; };
    const move = (e: TouchEvent) => { if (y0.current == null) return; const d = e.touches[0].clientY - y0.current; if (d > 0 && window.scrollY <= 0) { last.current = Math.min(110, d * 0.5); setPull(last.current); } else { y0.current = null; last.current = 0; setPull(0); } };
    const up = async () => {
      if (y0.current == null) return;
      y0.current = null;
      if (last.current >= 64) haptic();
      last.current = 0;
      setPull((p) => {
        if (p >= 64) { busy.current = true; setMsg("Refreshing"); onRefresh().then((m) => { setMsg(m); setTimeout(() => setMsg(null), 1800); }).finally(() => { busy.current = false; }); }
        return 0;
      });
    };
    window.addEventListener("touchstart", down, { passive: true });
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("touchend", up);
    return () => { window.removeEventListener("touchstart", down); window.removeEventListener("touchmove", move); window.removeEventListener("touchend", up); };
  }, [onRefresh]);
  if (!pull && !msg) return null;
  return (
    <div class="pull" style={`height:${msg ? 36 : pull}px`} aria-live="polite">
      <span class={`label${pull >= 64 || msg ? " ink" : ""}`}>{msg ?? (pull >= 64 ? "Let go to refresh" : "Pull to refresh")}</span>
    </div>
  );
}
